<template>
    <div id="CreateComment">
        <h3>{{ $t("task.comments") }}</h3>
        <div class="add-comment">
            <Avatar
                :size="35"
                :src="user.gravatar"
                :username="user.name"
            />
            <input
                type="text"
                class="comment-input"
                v-model="commentText"
                :placeholder="$t('task.addAComment')"
            />
            <button class="comment-submit-btn" @click="submitComment">{{ $t("task.addComment") }}</button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Avatar from "vue-avatar";

export default {
    name: "CreateComment",
    props: {
        taskId: {
            type: String,
            required: true,
        },
    },
    components: {
        Avatar,
    },
    data() {
        return {
            commentText: "",
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            createComment: "comments/createComment",
            fetchCommentsAction: "comments/fetchComments",
        }),
        async fetchComments() {
            try {
                await this.fetchCommentsAction({
                    siteId: this.site._id,
                    type: "task",
                    id: this.taskId,
                });
            } catch (error) {
                console.error("Error fetching comments:", error);
            }
        },
        async submitComment() {
            if (this.commentText.trim() === "") {
                return;
            }
            try {
                await this.createComment({
                    siteId: this.site._id,
                    commentData: {
                        task: this.taskId,
                        message: this.commentText,
                        user: this.user._id,
                        type: "task",
                    },
                });
                this.commentText = "";
                this.fetchComments();
            } catch (error) {
                console.error("Error creating comment:", error);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#CreateComment {
    margin-top: 30px;
    margin-bottom: 30px;
    max-width: 600px;

    h3 {
        font-size: 18px;
        margin-bottom: 15px;
        color: #333;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    .add-comment {
        display: flex;
        align-items: center;
        gap: 15px;
        padding: 15px 20px;
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        transition: background-color 0.3s, box-shadow 0.3s, transform 0.3s;

        &:hover {
            background-color: #f8f8f8;
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
            transform: translateY(-3px);
        }

        .comment-input {
            flex-grow: 1;
            padding: 10px 15px;
            background: #f1f1f1;
            border: 1px solid #ddd;
            border-radius: 30px;
            font-size: 14px;
            color: #333;
            transition: background-color 0.3s, border-color 0.3s, box-shadow 0.3s;

            &:focus {
                background-color: #fff;
                border-color: #ec4b1d;
                box-shadow: 0 0 5px rgba(236, 75, 29, 0.5);
                outline: none;
            }

            &::placeholder {
                color: #888;
            }
        }

        .comment-submit-btn {
            padding: 10px 20px;
            background-color: #ec4b1d;
            border: none;
            border-radius: 30px;
            color: white;
            font-weight: bold;
            font-size: 14px;
            cursor: pointer;
            transition: background-color 0.3s, transform 0.2s ease;

            &:hover {
                background-color: #d13a0d;
                transform: scale(1.05);
            }

            &:active {
                transform: scale(0.98);
            }
        }
    }
}
</style>
